/** DRF error payloads come as a string, a list, or nested {field: [msgs]} — one line of text either way. */
export function flattenApiErrors(errors: unknown): string {
  if (!errors) return "";
  if (typeof errors === "string") return errors;
  if (Array.isArray(errors)) return errors.map(flattenApiErrors).filter(Boolean).join(" ");
  if (typeof errors === "object") {
    return Object.values(errors as Record<string, unknown>).map(flattenApiErrors).filter(Boolean).join(" ");
  }
  return String(errors);
}

/** The server's own refusal text from an axios error, or `fallback`. */
export function apiErrorText(err: unknown, fallback: string): string {
  const e = err as { response?: { data?: { errors?: unknown } } } | null;
  return flattenApiErrors(e?.response?.data?.errors) || fallback;
}
